import { isRight } from "fp-ts/Either";
import { Json, JsonFromString } from "io-ts-types";

/**
 * Use this wrapper instead of accessing the `window` global directly. In NodeJS
 * contexts (where window access would throw an error), this function returns
 * null.
 */
export const getWindow = (): (Window & typeof globalThis) | null => {
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") {
        return null;
    }
    // eslint-disable-next-line no-restricted-globals
    return window;
};

/**
 * Use this wrapper instead of accessing the `document` global directly. In
 * NodeJS contexts (where document access would throw an error), this function
 * returns null.
 */
export const getDocument = (): Document | null => {
    // eslint-disable-next-line no-restricted-globals
    if (typeof document === "undefined") {
        return null;
    }
    // eslint-disable-next-line no-restricted-globals
    return document;
};

export const getJSONScriptData = (elemID: string): Json => {
    const document = getDocument();
    if (!document) {
        return null;
    }
    const contextElem = document.getElementById(elemID);
    const jsonStr = contextElem?.textContent || "{}";
    const maybeData = JsonFromString.decode(jsonStr);
    if (isRight(maybeData)) {
        return maybeData.right;
    }
    return null;
};
